import { withProps } from 'recompose';

import { UI } from 'app/features/success/components/MetaTitle';

const MetaTitle = withProps({ pageTitle: 'already_premium_meta_title' })(UI);

export default MetaTitle;
